module.exports = __webpack_public_path__ + "static/media/cwh.8db0cdbf.jpg";